import "./src/styles/global.css"
import "./src/styles/preloader.css"
import React from "react"
import { CurrencyProvider } from "./src/context/CurrencyContext"

export const wrapRootElement = ({ element }) => (
  <CurrencyProvider>{element}</CurrencyProvider>
)
